import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ElectronicInvoiceInterfaceDetailCaptureTableModel } from 'src/app/models/tables/invoicing/electronic-invoice-interface-detail-capture-table.model';
import { PendingSyncDocumentTableModel } from 'src/app/models/tables/invoicing/pending-sync-document-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ElectronicDocumentService {

  private readonly _httpClient = inject(HttpClient);

  checkElectronicDocument(typeDocument: number, documentId: number): Observable<any> {
    const params = new HttpParams().set('typeDocument', typeDocument).set('documentId', documentId);
    const headers = new HttpHeaders({ 'X-Skip-Loader': 'true' });
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.CheckElectronicDocumentAsync}`, { params, headers });
  }

  checkStatusDIAN(electronicInvoiceInterfaceId: number): Observable<PreInvoicingAlertModel[]> {
    return this._httpClient.get<PreInvoicingAlertModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.CheckStatusDIAN}/${electronicInvoiceInterfaceId}`);
  }

  downloadPdfAsync(document: ElectronicInvoiceInterfaceDetailCaptureTableModel): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('POST', `${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.DownloadPdfAsync}`,
      document, { reportProgress: true, responseType: 'blob' }));
  }

  exportPendingSyncDocuments(columnSort: string | null, ascendant: boolean, enterpriseId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('enterpriseId', enterpriseId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.ExportPendingSyncDocumentsAsync}`,
      null, { params, responseType: 'blob' }
    );
  }

  getColumnsForPendingSyncDocument(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.GetColumnsForPendingSyncDocumentAsync}`);
  }

  getElectronicDocuments(enterpriseId: number): Observable<PreInvoicingAlertModel> {
    return this._httpClient.get<PreInvoicingAlertModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.GetElectronicDocuments}/${enterpriseId}`);
  }

  getPendingSyncDocumentsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, enterpriseId: number): Observable<PagedResponseModel<PendingSyncDocumentTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('enterpriseId', enterpriseId);
    return this._httpClient.post<PagedResponseModel<PendingSyncDocumentTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.GetPendingSyncDocumentsWithPaginationAsync}`,
      null, { params: params }
    );
  }

  getSendMailAsync(electronicInvoiceInterfaceId: number): Observable<string> {
    return this._httpClient.get<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.GetSendMailAsync}/${electronicInvoiceInterfaceId}`);
  }

  resendEmailInvoice(invoiceId: number): Observable<HttpEvent<Array<PreInvoicingAlertModel>>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.ResendEmailInvoice}/${invoiceId}`));
  }

  resendEmailNote(noteId: number): Observable<HttpEvent<Array<PreInvoicingAlertModel>>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.ResendEmailNote}/${noteId}`));
  }

  sendElectronicDocuments(enterpriseId: number): Observable<PreInvoicingAlertModel[]> {
    return this._httpClient.get<PreInvoicingAlertModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.SendElectronicDocuments}/${enterpriseId}`);
  }

  sendMail(electronicInvoiceInterfaceId: number): Observable<PreInvoicingAlertModel[]> {
    return this._httpClient.get<PreInvoicingAlertModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.electronicDocument.SendMail}/${electronicInvoiceInterfaceId}`);
  }
}
